module.exports = __webpack_public_path__ + "img/img11.8d3b8ed6.png";